import React from "react";
import Modal from "components/common/Modal/Modal";
import CloseIcon from "assets/images/close.svg";
import DataTable from "components/common/DataTable/DataTable";
import { BodyDataAndKeyTypes } from "../PaiyaMov.contants";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import SearchIcon from "assets/images/search-icon.svg";
import "./PaiyaMovModal.scss";
import { IPaiyaMovModalProps } from "./PaiyaMovModal.interface";

const PaiyaMovModal = (props: IPaiyaMovModalProps) => {
  const {
    showModal,
    closeModal,
    handleMovSearchInputChange,
    searchTerm,
    movData,
    rowClickHandler,
    closeSearch,
    isSearch,
  } = props;
  return (
    <Modal
      showModal={showModal}
      modalHeading="Customer channel"
      closeModalHandler={closeModal}
      showProgressString={false}
      failedRecords=""
      modalBodyClass="customer-channel-modal"
    >
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <img src={SearchIcon} alt="search" />
          </InputGroupText>
        </InputGroupAddon>
        <Input
          className="search-input"
          placeholder="Search by customer channel"
          onChange={handleMovSearchInputChange}
          value={searchTerm}
          autoFocus={true}
        />
        <div
          className={isSearch ? "close-button" : "hide close-button"}
          onClick={closeSearch}
        >
          <img src={CloseIcon} alt="close" />
        </div>
      </InputGroup>
      <section className="customer-channel-list-container">
        <DataTable
          tableId="customer-channel-list"
          tableBodyDataTypes={BodyDataAndKeyTypes}
          tableBodyRowData={movData}
          editRowHandler={rowClickHandler}
        />
      </section>
    </Modal>
  );
};

export default PaiyaMovModal;
